import { useContext, useEffect } from 'react'
import ConnectorViewsTable from '../../../components/connector_views'
import { NavContext } from '../../../context/global_context'
import { createSearchParams, useParams } from 'react-router-dom'
import { getSessionStorageData } from '../../../utils/SessionStorage'

const ConnectorViews = () => {
  const { vehicle } = useParams()
  const [value, dispatch] = useContext(NavContext)

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: `Vehicle List / ${vehicle} / Vehicle Views`,
        id: '',
        show_back_btn: true,
        dtc_details: {},
        vehicle: vehicle,
        back_btn_url: getSessionStorageData('vehicle')?.search
          ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
          : `/vehicles`,
        full_width_container: false,
      },
    })
  }, [])

  return <ConnectorViewsTable />
}

export default ConnectorViews
